import {Cards} from "../../@types/demonstrationsCardsResources.tsx";
import serviceLogo1 from '/assets/images/home-page-images/icon-service-1.svg'
import serviceLogo2 from '/assets/images/online-banking-page-images/icon-demo-3.svg'

export const DonationDemonstrationsCardsConfig: Cards = {
    heading: 'other_demonstrations',
    cards: [
        {
            link: 'routes.demonstrations_bank_link_payments',
            image: serviceLogo1,
            title: 'payment_initiation'
        },
        {
            link: 'routes.demonstrations_self_service',
            image: serviceLogo2,
            title: 'self_service_2'
        }
    ]
}
